const RAKUTEN_TRAVEL_NAMBA_HOTELS_URL =
  "https://hb.afl.rakuten.co.jp/hgc/569e5e39.a7fdfcd3.569e5e3a.e3da74dd/?pc=https%3A%2F%2Fsearch.travel.rakuten.co.jp%2Fds%2Fhotellist%2FJapan-Osaka-Osaka-Namba&link_type=text&ut=eyJwYWdlIjoidXJsIiwidHlwZSI6InRleHQiLCJjb2wiOjF9";

const RAKUTEN_NMB_ITEMS = [
  {
    id: "yayoi_shine_on",
    name: "【デジタル限定】龍本弥生（NMB48）写真集「Shine on」 【電子書籍】[ 龍本弥生 ]",
    affiliateUrl:
      "https://hb.afl.rakuten.co.jp/ichiba/569e9f49.2e089dd9.569e9f4a.d32cdc23/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F62909e9332d73cfe8a8d823ed75937ee%2F&link_type=picttext&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0dGV4dCIsInNpemUiOiIyNDB4MjQwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjEsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D",
    imageUrl:
      "https://hbb.afl.rakuten.co.jp/hgb/569e9f49.2e089dd9.569e9f4a.d32cdc23/?me_id=1278256&item_id=26549086&pc=https%3A%2F%2Fthumbnail.image.rakuten.co.jp%2F%400_mall%2Frakutenkobo-ebooks%2Fcabinet%2F4988%2F2000021054988.jpg%3F_ex%3D240x240&s=240x240&t=picttext",
  },
  {
    id: "wakana_kaita_mirai",
    name: "描いた未来に君はいない [ 安部 若菜 ]",
    affiliateUrl:
      "https://hb.afl.rakuten.co.jp/ichiba/569e9477.38fda468.569e9478.e201cf37/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fbook%2F18489658%2F&link_type=picttext&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0dGV4dCIsInNpemUiOiIyNDB4MjQwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjEsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D",
    imageUrl:
      "https://hbb.afl.rakuten.co.jp/hgb/569e9477.38fda468.569e9478.e201cf37/?me_id=1213310&item_id=21835438&pc=https%3A%2F%2Fthumbnail.image.rakuten.co.jp%2F%400_mall%2Fbook%2Fcabinet%2F2965%2F9784041162965_1_8.jpg%3F_ex%3D240x240&s=240x240&t=picttext",
  },
  {
    id: "nmb_hajimete_no_all",
    name: "【楽天ブックス限定先着特典】初めてのオール (通常盤 Type-A CD＋Blu-ray)(生写真＜Type-A：坂田心咲1＞) [ NMB48 ]",
    affiliateUrl:
      "https://hb.afl.rakuten.co.jp/ichiba/569e9477.38fda468.569e9478.e201cf37/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fbook%2F18602072%2F&link_type=picttext&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0dGV4dCIsInNpemUiOiIyNDB4MjQwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjEsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D",
    imageUrl:
      "https://hbb.afl.rakuten.co.jp/hgb/569e9477.38fda468.569e9478.e201cf37/?me_id=1213310&item_id=21933592&pc=https%3A%2F%2Fthumbnail.image.rakuten.co.jp%2F%400_mall%2Fbook%2Fcabinet%2F7150%2F2100014947150_1_2.jpg%3F_ex%3D240x240&s=240x240&t=picttext",
  },
];

module.exports = {
  RAKUTEN_TRAVEL_NAMBA_HOTELS_URL,
  RAKUTEN_NMB_ITEMS,
};
